import { LogModel } from '../models';

export interface AuditLogFormatterProps {
  action: string;
  data: LogModel;
}
export default function AuditLogFormatter({
  action,
  data,
}: AuditLogFormatterProps) {
  let message = action;
  if (action === 'Profile.AddAddress') {
    message = `${data?.performedBy?.personName} (${data?.performedBy?.email}) updated Address`;
  } else if (action === 'Profile.AddPhoneNumber') {
    message = `${data?.performedBy?.personName} (${data?.performedBy?.email}) updated Phone Number`;
  }
  return <span data-exclude-lg>{message}</span>;
}
